module.exports = __webpack_public_path__ + "img/small-abstract-4.738b554.svg";